import { useState } from 'react'
import { Btn, Input, Field, Toggle, Modal } from '../../../components/ui/design.jsx'

const ALL_ROLES = ['super_admin', 'admin', 'editor']
const ROLE_LABEL = { super_admin: 'Super Admin', admin: 'Admin', editor: 'Editor' }
const ROLE_BADGE_CLS = {
  super_admin: 'bg-violet-100 text-violet-700 border-violet-200',
  admin:       'bg-blue-100 text-blue-700 border-blue-200',
  editor:      'bg-emerald-100 text-emerald-700 border-emerald-200',
}

export default function UserModal({ user, onClose, onSave }) {
  const isNew = !user
  const [form, setForm] = useState({
    name:                  user?.name  || '',
    email:                 user?.email || '',
    password:              '',
    password_confirmation: '',
    is_active:             user?.is_active ?? true,
    roles:                 user?.roles || ['editor'],
  })

  const toggleRole = (r) =>
    setForm((f) => ({
      ...f,
      roles: f.roles.includes(r)
        ? f.roles.filter((x) => x !== r)
        : [...f.roles, r],
    }))

  const handleSubmit = (e) => {
    e.preventDefault()
    onSave({ ...form, isNew, id: user?.id })
  }

  return (
    <Modal onClose={onClose} title={isNew ? 'Tambah Pengguna Baru' : `Edit ${user.name}`}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Field label="Nama" req>
          <Input
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            autoComplete="off"
          />
        </Field>

        <Field label="Email" req>
          <Input
            required
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            autoComplete="off"
          />
        </Field>

        {/* Password: required for new, optional for edit */}
        <Field label={isNew ? 'Kata Sandi' : 'Kata sandi baru (kosongkan = tidak diubah)'} req={isNew}>
          <Input
            type="password"
            minLength={8}
            required={isNew}
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            autoComplete="new-password"
          />
        </Field>

        <Field label="Konfirmasi kata sandi" req={isNew || !!form.password}>
          <Input
            type="password"
            minLength={8}
            required={isNew || !!form.password}
            value={form.password_confirmation}
            onChange={(e) => setForm({ ...form, password_confirmation: e.target.value })}
            autoComplete="new-password"
          />
        </Field>

        {/* Role chips */}
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">
            Hak akses
          </label>
          <div className="flex flex-wrap gap-2">
            {ALL_ROLES.map((r) => (
              <button
                key={r}
                type="button"
                onClick={() => toggleRole(r)}
                className={`rounded-lg border px-3 py-1.5 text-xs font-semibold transition-all ${
                  form.roles.includes(r)
                    ? `${ROLE_BADGE_CLS[r]} shadow-sm`
                    : 'border-gray-200 text-gray-500 hover:bg-gray-50'
                }`}
              >
                {form.roles.includes(r) && '✓ '}{ROLE_LABEL[r]}
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2.5">
          <Toggle checked={form.is_active} onChange={(v) => setForm({ ...form, is_active: v })} />
          <span className="text-sm text-gray-700">Akun aktif</span>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2">
          <Btn type="button" variant="secondary" onClick={onClose}>Batal</Btn>
          <Btn type="submit">Simpan</Btn>
        </div>
      </form>
    </Modal>
  )
}
